import type {
  PowerBiEmbeddedTokenResponse,
  PowerBiReportPagesResponse,
} from 'walden-fast/types/fast-backend/power-bi';
import type { Factory } from 'walden-fast/types/mocks';

export const MOCK_POWER_BI_EMBEDDED_TOKEN: PowerBiEmbeddedTokenResponse = {
  expiration: new Date(1734528816000),
  token:
    'H4sIAAAAAAAEAB2UxwrsCBZD_-VtPeCcBnrhnEM52zvnUM7Zbubfp7qXF3SROAj9_cdOn35Kiz___QN0Kq1fLKyFbvHFK4q9JsSRkIhzRmd5C03yqi5XY_pLUa8QTbYDLdWaQwQRNaHPchJw1HHrCVk2rwovZPRWlyWI5O_-dQrF1v1WVx-p5gECHa8FGDva0VPLiqFYGutJA6_iUCQdQ747RvnnLNZjD3Dfm6r3XXARYaZeTsHTeBRs5C30ZiyXfYdInOy7WQCHYMOE_pSFAxAlsGFll9XL213NtMGGLYH91yMeAT_NB5OGjS9OiI_LS9TTyh6zPkCaMnMWuqpeSRE5g6GuHBjuenz4NkblNL_ER_oYz3hU4TMReusXfWySqDYeAdpX80S5kzUk_pj8sgU3O4DvM5smj7YMQskm7FUj0FWH_zoKC5iV1yHEieeRlY4odWkl0XGt14I9K_WgRGe8pNxBAdVtaKkI7WCJozVQAGDAbMafsFe8PlmEadSAfP7YpmZZhm1SgPudbZSo7G_m-OpK4NHHu1JXGLNJTkiI9b3gynI47jBTdG7HrAXJiLCAuADyUO3Cozz7cz-ibbNlTKm53m_PoKR7HW83qhRphhfM-vAD-qzHkYAGAXduLKbjw4DduGb65gnaK4qg3WqOqR_kalqoeK8Zd0yBCuKuoGLAMsqZyjDcbUKYC8ofCu2D1C-xRB0UD8ueOV3dhfTIVAlTGmtm3eJfaTMwPBUuktYylM3SxttzeKuwEClJkfKApQlxoOKsNLuXvcW1UIyXUT_2s_FdM6qFOTUGVCr0QoJLhV0tG3H3xfFlV0SRvKlvreoGLw8syKzDuXvvLJnkQ6fm3Vc6BZ5F42kn9fvxN-YmhCv_gFIihy751pQOiXVSph3DHSzV7chs2cZ-1fbUkCTktg3IVNIqcvFpA6AY6V_XBROYkOct2g9pWLp0efOrRtLwUh32bHVfeWdQdbpjb5gx81a4sF0OPla2ouEnxykRrr95MYBeWRqrE7H5TDgDmUi7meWAVhv9BrklwmfwBABxddM3VPcjYZqTO_tg-UE5mWgmdxrpBwREk8f6O9H2jralQwVyAPC2mfQDEzXmyL8cDPl1ziLrw8JtBHhA8EbuesjvKhOBwTDJOpFwGMtOvrqLcDfBGS1RpN_vsRLtR5P7a23oUQvxK5Zkqbq-yxRLK0xOmkf4MjTAOCSgjdP0Su6L3Hb4re37Vv77DvQ-eUwlm-75yQw14aefZyr7nkHtVWV4KmkUDYknnUce4MSSv4WYi-8BWZcaxD08IlgdDSOAQzDUfBMtso7CgiWDjbpFsZF5q_2zqjEO0l09HcN3uFMT36nC2NuZKWM-eLp9Tx2BhU69ccovG-YWvozTTdfToOcoiX86xT4CFUs9eQLjw-PuutyxAtTu_s9__nDrM--TVj6_OS09gwWWxyX0LOcA5z0WyDOW3m0KYvH22eY362lMmHpggA8rGImaLaML5MQ8OSfTcT2jpGXgdEEwmhbQrB3vGJ9Zz-6OiWzz5hJ9V8Z7sqLnF7UXKhI27Jtb7f2A2OOIVst81RVYPWVdur61GDyxt-FTcANjd46aboiWgIXErLH0MBVNpfS2s2-xP21XXS1XuuVI02EAeL9AZbBjLBViWFTXH-5I-56FREghlPjXJ-EjdqNaQBt-AUt7AwWfvDbjxVwCma9m3zko5x3kLo0xg2fPB6wUJPmGmosV6JyrT0iCNubdoQBGonukHoJOdx_Ssjx67Z20pkbU76GqrATSSfXl-uuvfzA_c1OuSvCjrGfI9UwKviHLFTzHXI6RhjL_qty2HtP9WMufLNpomNIkfWajV1fI517XUDkho5cH8soKSx89w2TvhOa2Gg4cxjk7tm2e6AEs134zUU4DCM_5bEJJCYEdNsID5Zk0LG_z_vapD4_kFyAKSQjnlE4gSauqTuD9ru_0cWpYGhUmQKqNn9HZzjGFSnCG7PZblqSr0hFjZ2s-vJI0SoAqNj5r6zCIpcAcgJYb--ntSbQWcwqKymW38_wQrWxFuUYI6TWcZR44oPOgqaR-vPfo3bK6Apjb8tIx6Wkcl4xTEG_0uGjo0IAyfR6sxQk190vNQLz5qqlVSEJ_PA_UmHzeOcprBcKlEqJAk_p0nBy6knBMpSEn71ZQzHcbkLp5SVb9w_y__wMoPuXaQggAAA==.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUQtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImV4cCI6MTczMzkzNDAzMCwiYWxsb3dBY2Nlc3NPdmVyUHVibGljSW50ZXJuZXQiOnRydWV9',
  reports: [
    {
      displayName: 'Warehousing',
      id: '2607fd5b-a210-4b14-bc7d-91b485a9b28b',
      internalCode: 'Warehousing',
    },
    {
      displayName: 'Transport',
      id: 'b8db064b-0abb-49cd-8d97-410f578e47c0',
      internalCode: 'Transport',
    },
    {
      displayName: 'Order 2 Cash',
      id: 'd32c9ac5-bc27-4cfe-822d-cadbf1ba189d',
      internalCode: 'Order2Cash',
    },
    {
      displayName: 'OrderTracking',
      id: '28dcc1f5-3d1b-4055-9a83-1b856bfae3da',
      internalCode: 'OrderTracking',
    },
    {
      displayName: 'WaldenML',
      id: 'fc5e3ccd-4799-4b00-8ca1-9351e04ab86e',
      internalCode: 'WaldenML',
    },
    {
      displayName: 'Orchestration',
      id: '3b9d65bd-0803-4a04-be20-0dd15c7b2d83',
      internalCode: 'Orchestration',
    },
    {
      id: '55fc1347-3ad5-414b-b925-baa024422806',
      displayName: 'KPI 1',
      internalCode: 'KPI1',
    },
    {
      id: '39e8c8c4-ae88-4507-86cb-a99f3a660545',
      displayName: 'KPI 2',
      internalCode: 'KPI2',
    },
    {
      id: '875023e6-3f64-4401-b78b-d6096729c51b',
      displayName: 'KPI 3',
      internalCode: 'KPI3',
    },
    {
      id: '92fbe681-b30b-4534-b57b-53b78e660879',
      displayName: 'KPI 4',
      internalCode: 'KPI4',
    },
    {
      id: '60e659c5-4c8b-4169-a731-18ef13192b32',
      displayName: 'KPI 5',
      internalCode: 'KPI5',
    },
    {
      id: 'bf6c3170-6b68-4a5f-9f2e-ad4c84f4da94',
      displayName: 'KPI 6',
      internalCode: 'KPI6',
    },
    {
      id: '17840649-0a6e-4f59-9836-f51ac4f21a3e',
      displayName: 'Walden Green',
      internalCode: 'WaldenGreen',
    },
  ],
};

export const MOCK_POWER_BI_REPORT_PAGES: PowerBiReportPagesResponse = {
  reportPages: [
    {
      displayName: 'Inbound Outbound',
      id: 'ReportSection281aa592283d5bea89a5',
    },
  ],
};

export const MOCK_POWER_BI_REPORT_PAGES_WAREHOUSING: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'Inbound Outbound',
        id: 'ReportSection281aa592283d5bea89a5',
      },
      {
        displayName: 'Good receipts',
        id: 'ReportSection8d7472f1d00d89e65caa',
      },
      {
        displayName: 'Warehouse deliveries',
        id: 'ReportSectionaa27060df94b1afde2d0',
      },
      {
        displayName: 'Returns',
        id: 'ReportSectiondf31be00f27fa8fc916c',
      },
      {
        displayName: 'Inventory',
        id: 'ReportSection9fb5cdea586c50a41a45',
      },
      {
        displayName: 'Stock history',
        id: 'ReportSectionf449c465a2b90fbb9adf',
      },
      {
        displayName: 'Current stock',
        id: 'ReportSection55d316078d72bccd62c8',
      },
      {
        displayName: 'Quality status changes',
        id: '31e1cd6da3d0ec2dc0c2',
      },
      {
        displayName: 'Sales orders',
        id: 'ReportSection710fd4b1dadc3b5b03cd',
      },
      {
        displayName: 'Back orders',
        id: 'ReportSection4ea38cb49f320db2ddd3',
      },
      {
        displayName: 'Customers',
        id: 'ReportSection716f0509611068c99ce7',
      },
      {
        displayName: 'Items',
        id: 'ReportSectionde1996e9926b2d883c7f',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_TRANSPORT: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'Delivery performance',
        id: 'c358eeb9e020e632aa52',
      },
      {
        displayName: 'Delivery map',
        id: 'ReportSection7d0d4df3f89976e3fa99',
      },
      {
        displayName: 'Details & POD',
        id: 'ReportSection095597373d8b6470c07e',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_OTC: PowerBiReportPagesResponse = {
  reportPages: [
    {
      displayName: 'Dashboard',
      id: 'ReportSectionf4908b24aff8d720dc97',
    },
    {
      displayName: 'Balance sheet',
      id: 'ReportSection034d999902e69cdb9f0a',
    },
    {
      displayName: 'Invoices',
      id: 'ReportSection00098e5da9f1e7fe48fc',
    },
    {
      displayName: 'Aging',
      id: 'ReportSectionfc3f9c088e2e2fab3f85',
    },
    {
      displayName: 'Credit notes',
      id: 'ReportSection71888583d2118d4f4872',
    },
  ],
};

export const MOCK_POWER_BI_REPORT_PAGES_ORDER_TRACKING: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'Dashboard',
        id: 'ReportSection6f2015c4aa6586d8a504',
      },
      {
        displayName: 'Details',
        id: 'ReportSection716f0509611068c99ce7',
      },
      {
        displayName: 'Revenue recognition',
        id: '705df456c82181ebab83',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_ORDER_2_CASH: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'Dashboard',
        id: 'ReportSectionf4908b24aff8d720dc97',
      },
      {
        displayName: 'Balance sheet',
        id: 'ReportSection034d999902e69cdb9f0a',
      },
      {
        displayName: 'Invoices',
        id: 'ReportSection00098e5da9f1e7fe48fc',
      },
      {
        displayName: 'Aging',
        id: 'ReportSectionfc3f9c088e2e2fab3f85',
      },
      {
        displayName: 'Credit notes',
        id: 'ReportSection71888583d2118d4f4872',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_WALDEN_ML: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'WaldenML',
        id: 'cf60a398d033c5d3d2d2',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_DASHBOARD: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'Inventory',
        id: '8e8af46cac07c7ca4519',
      },
      {
        displayName: 'Warehouse Deliveries',
        id: 'd450ea91b9d134447a66',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_KPI: PowerBiReportPagesResponse = {
  reportPages: [
    {
      displayName: 'KPI 1',
      id: '6ef91b19aac975c5ebe0',
    },
  ],
};
export const MOCK_POWER_BI_REPORT_PAGES_WALDEN_GREEN: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'Walden Green',
        id: 'a2d22598-6b43-4388-88b9-cf144fb9349c',
      },
    ],
  };

export const MOCK_POWER_BI_REPORT_PAGES_ORCHESTRATION: PowerBiReportPagesResponse =
  {
    reportPages: [
      {
        displayName: 'System Availability',
        id: 'ReportSectionf5fec01b462c728d4099',
      },
      {
        displayName: 'Security',
        id: 'bacdfa3f104ce11a8e0a',
      },
      {
        displayName: 'HR',
        id: '4f74640945de000d74a0',
      },
      {
        displayName: 'Resource Commitment',
        id: '57d8d4f3db518c214778',
      },
    ],
  };

export const powerBiEmbeddedTokenResponseFactory: Factory<
  PowerBiEmbeddedTokenResponse
> = (overrides) => ({
  ...MOCK_POWER_BI_EMBEDDED_TOKEN,
  ...overrides,
});

export const powerBiReportPagesResponseFactory: Factory<
  PowerBiReportPagesResponse
> = (overrides) => ({
  ...MOCK_POWER_BI_REPORT_PAGES,
  ...overrides,
});
